import { Box, Grid, Stack, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { NewPasswordFormValues } from './types'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationNewPassword } from './validation'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { OPERATION_NEW_PASSWORD } from 'pages/Auth/operations-gql/mutations'
import NewSuccessPanel from './NewSuccessPanel'
import LoginPassword from '../../components/LoginPassword'

import LoginButton from '../../components/LoginButton'
import LoginPaper from '../../components/LoginPaper'

export interface INewPasswordPanelProps {
  token: string
}

const NewPasswordPanel = ({ token }: INewPasswordPanelProps) => {
  const { t } = useTranslation()

  const [newPassword, { data, loading }] = useMutation(OPERATION_NEW_PASSWORD)

  const {
    handleSubmit,
    register,
    formState: { errors, isValid }
  } = useForm<NewPasswordFormValues>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationNewPassword(t))
  })

  const onSubmit = ({ password, password_repeat }) => {
    newPassword({
      variables: { password, confirmation: password_repeat, token }
    })
  }

  if (data?.recovery?.status) {
    return <NewSuccessPanel />
  }

  return (
    <LoginPaper>
      <Stack gap={3} sx={{ alignItems: 'center', justifyContent: 'center' }}>
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '36px',
            fontWeight: 600,
            color: 'content.secondary'
          }}
        >
          {t('login.new_password')}
        </Typography>
        <Grid container spacing={2} maxWidth={'400px'}>
          <Grid item xs={12}>
            <LoginPassword
              name="password"
              placeholder={t('login.connection.password')}
              error={Boolean(errors.password)}
              errorMessage={errors.password?.message}
              InputProps={{
                ...register('password', { required: true })
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <LoginPassword
              name={'password_repeat'}
              placeholder={t('login.confirmation_password')}
              error={Boolean(errors.password_repeat)}
              errorMessage={errors.password_repeat?.message}
              InputProps={{
                ...register('password_repeat', { required: true })
              }}
            />
          </Grid>
        </Grid>

        <Box display="flex" width="100%">
          <LoginButton loading={loading} variant="contained" onClick={handleSubmit(onSubmit)} disabled={!isValid}>
            {t('login.validate')}
          </LoginButton>
        </Box>
      </Stack>
    </LoginPaper>
  )
}

export default NewPasswordPanel
